import { Fragment } from 'react';
import PropTypes from 'prop-types';
import oneLine from 'common-tags/lib/oneLine';

import markdown from '../markdown';

import { resolveScopedStyles } from 'core/utils/styled-jsx';


export default function Interview(block, parentProps, ctx) {
  const {
    attributes: {
      interviewer_name: interviewerName,
      question,
      answers,
    },
  } = block;

  const {
    theme: {
      controls: {
        interview: atoms,
      },
    },
  } = parentProps;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .name
          font-weight bold

        .interviewerName
          color ${atoms.question.name.color}

        .question
          font-style ${atoms.question.body.fontStyle}
      `}</style>
    </scope>
  );

  const questionWithName = oneLine`
    <span class="${scope.wrapClassNames('name', 'interviewerName')}">
      ${interviewerName}:
    </span>
    <span class="${scope.wrapClassNames('question')}">
      ${question}
    </span>
  `;

  const answersWithNames = answers.reduce((acc, answer, i) => {
    const {
      attributes: {
        answer: answerBody,
        interviewee_name: intervieweeName,
      },
    } = answer;

    const answerHtml = oneLine`
      <span class="${scope.wrapClassNames('name')}">
        ${intervieweeName}:
      </span>
      ${answerBody}
    `;

    return `${acc} ${answerHtml}${i < answers.length && '\n\n'}`;
  }, '');

  return (
    <Fragment>
      {markdown(
        {
          attributes: {
            body: questionWithName + '\n\n' + answersWithNames,
          },
        },
        {
          ...parentProps,
        },
        ctx,
      )}
      <scope.styles />
    </Fragment>
  );
}

Interview.propTypes = {
  /**
   * Данные о виджете
   */
  block: PropTypes.object,
  /**
   * Данные которые уже есть в топике и нужны виджету
   */
  parentProps: PropTypes.object,
  /**
   * Данные из контекста топика:
   * + реклама
   * + колличество символов
   */
  ctx: PropTypes.object,
};
